import { useState } from 'react';
import { useLocation } from 'react-router';
import {
  ABOUT_US_PAGE_ROUTE,
  BUSINESS_LOAN_PAGE_ROUTE,
  GST_ROUTE,
  HOME_PAGE_ROUTE,
  PERSONAL_LOAN_PAGE_ROUTE,
} from '../../data/routes-constants';
import './common.css';

const Partners = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();
  const isBusinessLoanPage =
    location.pathname === BUSINESS_LOAN_PAGE_ROUTE ||
    location.search.indexOf('BL') !== -1 ||
    location.pathname === GST_ROUTE;
  const isPersonalLoanPage = location.pathname === PERSONAL_LOAN_PAGE_ROUTE;
  const isHomePage = location.pathname === HOME_PAGE_ROUTE;
  const isAboutPage = location.pathname === ABOUT_US_PAGE_ROUTE;

  const showMore = (e) => {
    e.preventDefault();
    const ViewMoreBtn = e.target;

    setIsExpanded(!isExpanded);

    const icons = document.querySelectorAll('.extra-icons');
    icons.forEach((icon) => {
      if (icon.style.display === 'none' || icon.style.display === '') {
        icon.style.display = 'block';
        icon.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 1000 });
      } else {
        icon.animate([{ opacity: 1 }, { opacity: 0 }], {
          duration: 1000,
        }).onfinish = () => {
          icon.style.display = 'none';
        };
      }
    });

    ViewMoreBtn.textContent = isExpanded ? 'View More' : 'View Less';

    if (isExpanded) {
      document
        .getElementById('partners')
        .scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      document
        .getElementById('partners')
        .scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  };

  return (
    <section className="dc_sec_space partner_outerinfos" id="partners">
      <div className="container">
        <div className="dc_small_title tw-pointer-events-none tw-select-none">
          Our Partners
        </div>
        <div className="dc_partners_list tw-pointer-events-none tw-select-none">
          <ul>
            {(isHomePage || isAboutPage || isBusinessLoanPage) && ( // Bajaj
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon22.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {
              // IIFL
              <li>
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon3.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            }
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Flexiloans
              <li>
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon4.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Credit Saison
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon26.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // neo growth
              <li>
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon8.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {
              // godrej
              <li>
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon9.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            }
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Piramal
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon29.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // lendingKart
              <li>
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon6.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // indifi
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon18.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Protium
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon12.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {
              // Tata
              <li>
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon10.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            }
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Poonawala
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon23.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Ugro
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon19.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Arka
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon27.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isPersonalLoanPage || isHomePage || isAboutPage) && ( // InCred
              <li>
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon2.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // KreditBee
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon24.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Ambit
              <li>
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon5.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isHomePage || isAboutPage) && ( // Standard Chartered
              <li>
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon7.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}

            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // LnT
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon11.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}

            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Clix
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon13.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {
              // ICICI
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon14.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            }
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Chola
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon15.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage ||
              isPersonalLoanPage ||
              isHomePage ||
              isAboutPage) && ( // SMFG
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon32.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Aditya
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon17.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isPersonalLoanPage || isHomePage || isAboutPage) && ( // Fibe
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon20.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isPersonalLoanPage || isHomePage || isAboutPage) && ( // pay sense
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon21.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Tru
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon25.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // MAS
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon28.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Axis
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon30.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Hero fincorp
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon31.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
            {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Yes bank
              <li className="extra-icons">
                <div className="dc_pbox">
                  <img
                    className="tw-max-w-[90px] tw-max-h-[32px]"
                    src={require('../../assets/images/dc_op_icon33.webp')}
                    alt=""
                    loading="lazy"></img>
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="know_partner">
        <a className="tw-rounded-[4px]" onClick={showMore}>
          View more
        </a>
      </div>
    </section>
  );
};

export default Partners;
